// const BASE_URL = process.env.REACT_APP_API_URL || "http://143.248.30.34:3100"; // API 베이스 URL
const BASE_URL = process.env.REACT_APP_API_URL || "https://mri.kaist.ac.kr:3100"; // API 베이스 URL

/**
 * quill_data 가져오기
 * @param {string} name - 요청할 데이터의 이름
 * @returns {Promise<string>} - 쿼리된 quill 데이터를 반환
 */
export async function fetchQuillData(name) {
  try {
    const response = await fetch(`${BASE_URL}/quill_data?${name}`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data.quill; // quill 필드만 반환
  } catch (error) {
    console.error("Fetch error:", error);
    return ""; // 오류 시 빈 문자열 반환
  }
}

/**
 * prof_info 가져오기
 * @returns {Promise<Array>} - 교수 정보 목록 반환
 */
export async function fetchProfInfo() {
  try {
    const response = await fetch(`${BASE_URL}/prof_info`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    return await response.json(); // 서버로부터 받은 교수 정보 배열 반환
  } catch (error) {
    console.error("Fetch error:", error);
    return []; // 오류 시 빈 배열 반환
  }
}


export async function fetchAlbumData() {
  try {
    const response = await fetch(`${BASE_URL}/album`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    // 각 graduate 항목에 이미지 경로 path 추가 (예: /image/{id}.jpg)
    return data.map((image) => ({
      ...image, path: `${BASE_URL}/album/${image.id}.jpg` // 이미지 경로를 직접 추가
    }));
  } catch (error) {
    console.error("Fetch error:", error);
    return []; // 오류 시 빈 배열 반환
  }
}

/// 추가 된거
/**
 * home_carousel_image 데이터 가져오기
 * @returns {Promise<Array>} - 이미지 파일 이름 배열을 반환
 */
export async function fetchHomeCarouselImages() {
  try {
    const response = await fetch(`${BASE_URL}/home_carousel_image`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data.images; // 이미지 파일 이름 배열 반환
  } catch (error) {
    console.error("Fetch error:", error);
    return []; // 오류 시 빈 배열 반환
  }
}

/**
 * Professor Image 가져오기
 * @returns {Promise<string>} - 교수 이미지의 URL 반환
 */
export async function fetchProfImage() {
  try {
    const response = await fetch(`${BASE_URL}/prof_image`);

    if (!response.ok) {
      throw new Error("Failed to fetch professor image");
    }

    // 이미지 경로 반환
    return `${BASE_URL}/prof_image/prof.png`;
  } catch (error) {
    console.error("Fetch error:", error);
    return ""; // 오류 시 빈 문자열 반환
  }
}

/**
 * student_type 데이터 가져오기
 * @returns {Promise<Array>} - student_type 테이블의 id와 type 데이터를 반환
 */
export async function fetchStudentTypes() {
  try {
    const response = await fetch(`${BASE_URL}/student_type`);
    if (!response.ok) {
      throw new Error("Failed to fetch student types");
    }
    const data = await response.json();
    return data; // student_type 데이터 반환
  } catch (error) {
    console.error("Error fetching student types:", error);
    return []; // 오류 발생 시 빈 배열 반환
  }
}

export async function fetchStudent() {
  try {
    // 서버로부터 학생 데이터를 가져옴
    const response = await fetch(`${BASE_URL}/students`);
    if (!response.ok) {
      throw new Error("Failed to fetch students");
    }
    const students = await response.json();

    // 각 학생의 이미지 경로를 추가
    return students.map((student) => ({
      ...student,
      path: `${BASE_URL}/images/student${student.id}.jpg` // 이미지 경로 추가
    }));
  } catch (error) {
    console.error("Error fetching students:", error);
    return [];
  }
}
